import React from 'react';
export function SolutionSection() {
  return <section className="w-full bg-black py-16 px-4" data-id="element-311">
      <div className="max-w-4xl mx-auto text-center" data-id="element-312">
        <div className="inline-flex items-center gap-2 border border-[#FFD700]/50 text-[#FFD700] font-bold text-sm px-5 py-2 rounded-full mb-8 tracking-wide" data-id="element-313">
          🏆 Sistema N°1 para Profesores de Tango en Argentina
        </div>

        <h2 className="text-4xl sm:text-5xl font-black text-white mb-4" data-id="element-314">
          💃 PROFEPACK™
        </h2>
        <h3 className="text-2xl sm:text-3xl font-bold text-[#FFD700] mb-6" data-id="element-315">
          MEGAPACK TANGO LISTO
        </h3>
        <p className="text-white text-lg max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-316">
          <strong data-id="element-317">
            6 Tomos + 6 Bonos — Todos los niveles — Todo resuelto.
          </strong>
          <br data-id="element-318" />
          +400 páginas · 18 secuencias · 40 ejercicios · 80+ guiones de
          corrección · Musicalidad · Retención · Negocio. Funciona desde hoy.
        </p>

        <div className="relative mx-auto mb-10 max-w-2xl" data-id="element-319">
          <div className="grid grid-cols-6 gap-2 justify-center" data-id="element-320">
            {['#1565C0', '#2E7D32', '#E65100', '#6A1B9A', '#37474F', '#BF360C'].map((color, i) => {
            const labels = ['Fundamentos y Metodología', 'Laboratorio de Técnica', 'Musicalidad en el Salón', 'Retención y Motivación', 'Guiones de Corrección Avanzada', 'El Negocio del Profe'];
            return <div key={i} className="aspect-[3/4] rounded-lg shadow-2xl flex items-end justify-center pb-2 px-1" style={{
              backgroundColor: color,
              border: '2px solid #FFD700'
            }} data-id="element-321">
                  <span className="text-white text-[10px] sm:text-xs font-bold text-center leading-tight" style={{
                textShadow: '0 1px 3px rgba(0,0,0,0.8)'
              }} data-id="element-322">
                    {labels[i]}
                  </span>
                </div>;
          })}
          </div>
          <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 bg-[#FFD700] text-black font-black text-xs px-4 py-1 rounded-full whitespace-nowrap" data-id="element-323">
            6 TOMOS COMPLETOS
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mt-8 max-w-2xl mx-auto" data-id="element-324">
          <span className="bg-[#FFD700]/10 text-[#FFD700] text-xs font-bold px-3 py-2 rounded-lg text-center" data-id="element-325">
            ✅ Por nivel
          </span>
          <span className="bg-[#FFD700]/10 text-[#FFD700] text-xs font-bold px-3 py-2 rounded-lg text-center" data-id="element-326">
            ✅ 80+ guiones
          </span>
          <span className="bg-[#FFD700]/10 text-[#FFD700] text-xs font-bold px-3 py-2 rounded-lg text-center" data-id="element-327">
            ✅ Evaluación + rúbricas
          </span>
          <span className="bg-[#FFD700]/10 text-[#FFD700] text-xs font-bold px-3 py-2 rounded-lg text-center" data-id="element-328">
            ✅ Retención + negocio
          </span>
        </div>
      </div>
    </section>;
}